import { FC } from "react";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { IDisplayItem } from "./InvoiceUpdateForm";
import styles from './../InvoiceItem/styles/InvoiceItemCreatorView.module.scss'

interface IInvoiceItemAlertCellProps {
    item: IDisplayItem;
}

export const InvoiceItemAlertCell: FC<IInvoiceItemAlertCellProps> = ({item}) => {
    const { t } = useTranslation();
    const baseT = (value: string) => t("documents.invoice." + value);

    const registerPrice = item?.registerPrice // Предельная цена произв.
    const producerPrice = item?.producerPrice // Цена производителя
    const isGnvls = item?.isGnvls
   
    const getTitle = (producerPrice: number, registerPrice: number) => {
        if(producerPrice > registerPrice) return baseT('exceedingProducerPrice')
    }

    return (
        isGnvls && producerPrice > registerPrice ? (
            <Tooltip
                title={getTitle(producerPrice, registerPrice)}
                placement="top"
                autoAdjustOverflow={false}
                getPopupContainer={() => document.body}
            >
                <div className={styles.alertCircle}>?</div>
            </Tooltip>
        ) : <></>
    );
};